import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { analytics } from "@heycatch/sdk";
import "@/index.css";
import App from "@/App";

// HeyCatch analytics — module scope, static import, key inlined as a literal
// per https://heycatch.ai/agents.md. Autocapture handles pageviews, clicks,
// and SPA route changes from here forward; do not hand-instrument UI events.
analytics.init({
  projectKey: "hck_pk_1uMpOrqOWUngH4aQ6RRT_R1EJwsyi9iM",
  install: {
    framework: "react",
    frameworkVersion: "19",
    agent: "claude-code",
  },
});

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

ReactDOM.createRoot(rootElement).render(app);
